export default "<div class=\"inside_top_header pageHeader\">\n    <app-top-header></app-top-header>\n  </div>\n  <router-outlet></router-outlet>\n";